import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useAuth } from '../contexts/AuthContext';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonatedUser, activeOrg, stopImpersonating } = useAuth();

  if (!isImpersonating) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        px: 2,
        py: 1,
        backgroundColor: '#f59e0b',
        color: '#000',
        flexShrink: 0,
      }}
    >
      <WarningAmberIcon fontSize="small" />
      <Typography variant="body2" fontWeight={600}>
        Viewing as {impersonatedUser?.email || 'unknown user'}
        {activeOrg ? ` (${activeOrg.name})` : ''}
      </Typography>
      <Button
        size="small"
        variant="contained"
        onClick={stopImpersonating}
        sx={{
          ml: 1,
          backgroundColor: '#000',
          color: '#f59e0b',
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': { backgroundColor: '#1a1a1a' },
        }}
      >
        Stop Impersonating
      </Button>
    </Box>
  );
};

export default ImpersonationBanner;
